import { useMemo } from 'react'

import { LOCATIONS_SEPARATOR } from '../../../../configs'

import styles from './LocationsListDialogContent.module.scss'

interface ILocationsListDialogContentProps {
  locations: string
}

export const LocationsListDialogContent = ({
  locations: locationsString,
}: ILocationsListDialogContentProps) => {
  const locations = useMemo(() => {
    return locationsString.split(LOCATIONS_SEPARATOR).filter((it) => it)
  }, [locationsString])

  return (
    <div className={styles.root}>
      <div className={styles.listContainer}>
        {locations.map((location, index) => {
          const locationTitle = `${index + 1}. ${location}`

          return (
            <div className={styles.locationItem} key={locationTitle}>
              {locationTitle}
            </div>
          )
        })}
      </div>
    </div>
  )
}
